import React from "react";
import { RCCAlert, RCCDropDownItem, RCCIcon } from "react-common-components";
import OptionsColumn from "src/components/DefaultColumnsList/Options";
import ListCardOKR from "src/components/OrgChart/components/ListCardOKR";
import ListOKR from "src/components/OrgChart/components/ListOKR";
import { TabsOKRMODAL } from "src/components/OrgChart/objectives/interface";
import { useAuth } from "src/context/Auth/context";
import { PermissionEnum } from "src/context/Auth/interface";
import { useTranslation } from "src/context/Translations/context";
import { IListOfOKRs } from "./interface";

const ListOfOkrs: React.FC<IListOfOKRs> = ({
	data,
	onViewHierarchy,
	callbackOnDelete,
	callbackOnUpdate,
	openModalAddOrChange,
	openModalDelete,
	openModalOKRAttachments,
	openModalOKRComments,
	layoutList
}) => {
	const { translate } = useTranslation();
	const { administrator, user, superUser, checkIfHasSpecificPermission } = useAuth();

	const hasPermissionToView = checkIfHasSpecificPermission("okr/panel", PermissionEnum.VIEW);
	const hasPermissionToChange = checkIfHasSpecificPermission("okr/panel", PermissionEnum.CREATE_UPDATE);
	const hasPermissionToDelete = checkIfHasSpecificPermission("okr/panel", PermissionEnum.CREATE_UPDATE_DELETE);

	const internalDisabled = (row: any) => !((hasPermissionToChange && row?.permissions > 1) || administrator || superUser);

	const options = (row: any) => (
		<OptionsColumn>
			<RCCDropDownItem
				selfEnclose
				onClick={() => { if(!openModalAddOrChange) return; openModalAddOrChange(row.oka001Id, undefined, () => {
					if(!callbackOnUpdate)
						return;

					callbackOnUpdate(row.oka001Id);
				}); 
				}}
			>
				<RCCIcon name={hasPermissionToView && !hasPermissionToChange ? "eye" : "pencil"}/>
				{hasPermissionToView && !hasPermissionToChange ? translate("Visualizar") : translate("Alterar")}
			</RCCDropDownItem>
			<RCCDropDownItem
				selfEnclose
				onClick={() => { 
					if(!openModalOKRAttachments) return; 
					openModalOKRAttachments(row.oka001Id, `${row.oka001Codigo} - ${row.oka001Titulo}`, undefined, internalDisabled(row));
				}}
			>
				<RCCIcon name="attachment" />
				{translate("Anexos")}
			</RCCDropDownItem>
			<RCCDropDownItem
				selfEnclose
				onClick={() => {if(!openModalOKRComments) return; openModalOKRComments(row.oka001Id, `${row.oka001Codigo  } - ${row.oka001Titulo}`, undefined, internalDisabled(row));}}
			>
				<RCCIcon name="comment" />
				{translate("Comentários")}
			</RCCDropDownItem>
			{((administrator || row.oka001Efa005Id === user.efa005Id ||  row.oka001Efa005Id2 === user.efa005Id) && hasPermissionToDelete) &&
				<RCCDropDownItem 
					selfEnclose
					onClick={() => { if(!openModalDelete) return; openModalDelete(row.oka001Id, row.oka001Titulo, () => {
						if(!callbackOnDelete)
							return;
					
						callbackOnDelete(row.oka001Id); 
					}); 
					}}
				>
					<RCCIcon name="trash" />
					{translate("Excluir")}
				</RCCDropDownItem>
			}
		</OptionsColumn>
	);

	const openKRs = (id: number) => { if(!openModalAddOrChange) return; openModalAddOrChange(id, undefined, () => {
		if(!callbackOnUpdate)
			return;

		callbackOnUpdate(id);
	}, TabsOKRMODAL.KEY_RESULTS); 
	};

	if(!data || data.length === 0)
		return (
			<RCCAlert 
				title={translate("Atenção")}
				description={translate("Não foram encontrados dados")}
			/>
		);

	return (
		<>
			{layoutList === "card" ? (
				<ListCardOKR 
					data={data}
					options={options}
					onViewHierarchy={onViewHierarchy}
					openKRs={openKRs}
				/>
			): (
				<ListOKR 
					data={data} 
					options={options}
					onViewHierarchy={onViewHierarchy}
					openKRs={openKRs}
				/>
			)}
		</>
	);
};

export default ListOfOkrs;
